import { useJobFunctionOptions } from "lib/hooks/api/contacts/useJobFunctionOptions";
import LabelledMultiSelectFilter from "./LabelledMultiSelectFilter";

export type JobFunctionFilterProps = {
  value: string[];
  onChange: (value: string[]) => void;
};

/**
 * Multi-select for the unified job function. Self-contained: fetches its own
 * backend-served options (React Query dedupes across instances) and emits the selected
 * function slugs. Rendered as a labelled select so it matches the buyer selects in the sidebar.
 */
function JobFunctionFilter({ value, onChange }: JobFunctionFilterProps) {
  const { data } = useJobFunctionOptions();
  const options = (data ?? []).map((o) => ({ label: o.label, value: String(o.value) }));

  return (
    <LabelledMultiSelectFilter
      label="Job function"
      placeholder="Select job function"
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}

export default JobFunctionFilter;
